import { Form, DatePicker, Button, Divider, Row, Col, Card } from "antd";
import moment from "antd/node_modules/moment";
import { observer } from "mobx-react";
import React from "react";
import { useHistory } from "react-router";

export interface FilterBarType {
  store: any;
  children?: any;
  actions?: any;
  actionsSpan?: number;
}

export const FilterBar = observer(({ store, children, actions, actionsSpan }: FilterBarType) => {
  const history = useHistory();

  const onSearch = () => store.onSearch(history);
  const onReset = () => store.filterStore.onReset(history);
  const onRefresh = () => store.refresh();

  const { showSearchBtn, showResetBtn, periodLabel } = store.filterStore;

  return (
    <Card size="small" className="fm-filter-bar" bodyStyle={{ paddingBottom: 0 }}>
      <Form size="small" initialValues={store.filter}>
        <Row gutter={24}>
          {store.filterStore.showPeriod && (
            <Col span={8}>
              <Form.Item label={periodLabel}>
                <DatePicker.RangePicker
                  allowClear
                  style={{ width: "100%" }}
                  value={store.filter.period}
                  onChange={(e) => store.filterStore.onPeriod(e)}
                  ranges={{
                    Today: [moment(), moment()],
                    "This Week": [moment().startOf("week"), moment().endOf("week")],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "This Year": [moment().startOf("year"), moment().endOf("year")],
                  }}
                />
              </Form.Item>
            </Col>
          )}
          {children}
          {actionsSpan && (
            <Col span={actionsSpan} style={{ textAlign: "right" }}>
              {showSearchBtn && (
                <Button type="primary" ghost onClick={() => onSearch()}>
                  Search
                </Button>
              )}
              {showResetBtn && <Button onClick={() => onReset()}>Reset</Button>}
              <Button onClick={() => onRefresh()}>Refresh</Button>
              {actions && <Divider type="vertical" />}
              {actions}
            </Col>
          )}
        </Row>
        {!actionsSpan && (
          <Row>
            <Col span={24} style={{ textAlign: "right", paddingBottom: 12 }}>
              {showSearchBtn && (
                <Button type="primary" ghost onClick={() => onSearch()}>
                  Search
                </Button>
              )}
              {showResetBtn && <Button onClick={() => onReset()}>Reset</Button>}
              <Button onClick={() => onRefresh()}>Refresh</Button>
              {actions && <Divider type="vertical" />}
              {actions}
            </Col>
          </Row>
        )}
      </Form>
    </Card>
  );
});
